import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store' 
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'vue3-tree-vue/dist/style.css'
const app =createApp(App);
app.use(store).use(router).mount('#app')
